import { z } from "zod";
import type { components } from "#/schema";

/**
 * Typed URL search for the student-detail statistics tab.
 * `leerjaar` is client-side display state (no loader re-run); the filter-id
 * selections re-run the loader against the combined statistics endpoint.
 */
export const leerlingStatisticsSearchSchema = z.object({
  selectedLeerlijnFilterIds: z.array(z.string()).default([]),
  selectedDomeinFilterIds: z.array(z.string()).default([]),
  leerjaar: z.string().optional(),
});

export type LeerlingStatisticsFilters = z.infer<typeof leerlingStatisticsSearchSchema> & {
  leerjaar?: components["schemas"]["Leerjaar"];
};

export const leerlingStatisticsSearchDefaults = {
  selectedLeerlijnFilterIds: [],
  selectedDomeinFilterIds: [],
};
